import { render } from "./ExternalExamMediaTab.vue?vue&type=template&id=344b998a&scoped=true"
import script from "./ExternalExamMediaTab.vue?vue&type=script&lang=js"
export * from "./ExternalExamMediaTab.vue?vue&type=script&lang=js"

import "./ExternalExamMediaTab.vue?vue&type=style&index=0&id=344b998a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344b998a"]])

export default __exports__